/*
    sidebar component should be a component usable for all main views
*/
import React, {useState} from 'react';
import t from '../../../helpers/t';
import {$, Foundation, moment, DropdownButton, Dropdown} from "../../../../../vendor";
import {getApiHost} from "../../../../Sync";
import {Biscuit,getAllUrlParams} from "../../../../utils";
import * as FileSaver from "../../../../../vendor/FileSaver";
import SidebarFilter from "../../../components/SidebarFilter";
import {getFilterData} from "../../../../utils/Helper";


const InvoiceSidebar = (props) => {
    const { filter, setFilter,externInvoicesSummaryPending, externInvoicesSummary, nameList, sync, uploadInvoiceCSV,  index,
        dispatch,  setNKey,
        sort,
        setSort,
        currentUrl,
        checkedItems,onCheckBox,_readFile,withActions, getSepaXML,cleanStateFilters,setFilters} = props;
    const searchParams = currentUrl.searchParams;
    const allUrlParams = getAllUrlParams(window.location.href);
    const [globalFilter, setGlobalFilter] = useState(filter);           // set empty object, there are no filters set by default
    const cleanState = {yearFilter:false,paymentMethodFilter:false,paymentStatusFilter:false,dateFilter:false,systemFilter:false,warningLevelFilter:false,nameFilter:false};
    const [usedFilterCount,setUsedFilterCount] = useState(
        {yearFilter:allUrlParams?.year !== undefined ? true : false,
            paymentMethodFilter:allUrlParams?.paymentMethod !== undefined ? true : false,
            paymentStatusFilter:allUrlParams?.paymentState !== undefined ? true : false,
            fromFilter:allUrlParams?.invoiceDate_gte !== undefined ? true : false,
            toFilter:allUrlParams?.invoiceDate_lte !== undefined ? true : false,
            systemFilter:allUrlParams?.systemFilter !== undefined ? true : false,
            warningLevelFilter:allUrlParams?.warningLevelFilter !== undefined && allUrlParams?.date_lte !== undefined ? true : false,
            nameFilter:allUrlParams?.nameFilter !== undefined && allUrlParams?.date_lte !== undefined ? true : false
        });
    const [filterCount, setFilterCount] = useState(Object.keys(allUrlParams).length > 0 ? Object.keys(allUrlParams).length : 0);
    const [yearFilter, setYearFilter] = useState(searchParams.get("year") !== null ? searchParams.get("year")  : moment().format('YYYY') );       // 'all', 'active', 'inactive'
    const [selectedDateFrom,setSelectedDateFrom] = useState(searchParams.get("invoiceDate_lte") !== null ? searchParams.get("invoiceDate_lte") : null);
    const [selectedDateTo,setSelectedDateTo] = useState(searchParams.get("invoiceDate_gte") !== null ? searchParams.get("invoiceDate_gte") : null);
    const [nameFilter, setNameFilter] = useState( searchParams.get("name") !== null ? searchParams.get("name") : "");
    const [systemFilter, setSystemFilter] = useState( {value:searchParams.get("system") !== null ? searchParams.get("system") : ""});
    const [paymentMethodFilter, setPaymentMethodFilter] = useState( searchParams.get("paymentMethod") !== null ? searchParams.get("paymentMethod") : "");
    const [paymentStatusFilter, setPaymentStatusFilter] = useState( searchParams.get("paymentStatus") !== null ? searchParams.get("paymentStatus") : "");
    const [warningLevelFilter, setWarningLevelFilter] = useState( searchParams.get("warningLevel") !== null ? searchParams.get("warningLevel") : "");

    const onToggleLeftBar = (ev) => {

        $('#inb-c-sidebar').toggleClass('open');
        $('html,body').scrollTop(0);
    };
    const onFilterCountChangeHandle = (value) => {
        let clone = {...value};
        let count = 0;
        for (const [type, val] of Object.entries(clone)) {
            if(val){
                count++;
            }
        }
        if(count < 1){
            count = 0;
            $('#inb-selected-filters').addClass('hidden');
        } else {
            $('#inb-selected-filters').removeClass('hidden');
        }
        setFilterCount(count);

    };
    const resetFilter = () =>
    {
        let clone = {};
        setYearFilter("");
        setPaymentMethodFilter('');
        setPaymentStatusFilter('');
        setSelectedDateFrom("");
        setSelectedDateTo("");
        setNameFilter("");
        setSystemFilter('');
        setWarningLevelFilter('');
        setFilterCount(0);
        setUsedFilterCount(cleanState);
        onFilterCountChangeHandle(cleanState);

        const newRelativePathQuery = window.location.pathname;
        history.pushState(null, "", newRelativePathQuery);
        setFilters(cleanStateFilters);
        //setFilter(cleanStateFilters);

    }

    const onPaymentTypeSelectHandle = (paymentType) => {

        let clone = {...globalFilter};
        let clone2 = {...usedFilterCount};
        if (paymentType !== '') {
            // add status filter to global filter
            clone.paymentMethod = paymentType;
            clone2.paymentMethodFilter = true;
            searchParams.set('paymentMethod', paymentType);
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        } else {
            // remove status filter from global filter
            delete clone['payment_type'];
            clone2.paymentMethodFilter = false;
            searchParams.delete('paymentMethod');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
        setPaymentMethodFilter(paymentType);
        setUsedFilterCount(clone2);

        setGlobalFilter(clone);
        onFilterCountChangeHandle(clone2);
        // fetch wallet transactions
        setFilter(clone);
    };

    const onPaystateSelectHandle = (payState) => {
        let clone = {...globalFilter};
        let clone2 = {...usedFilterCount};
        if (payState !== '') {
            // add status filter to global filter
            clone.paymentStatus= payState;
            clone2.paymentStatusFilter = true;
            searchParams.set('paymentStatus', payState);
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        } else {
            // remove status filter from global filter
            delete clone['paymentStatus'];
            clone2.paymentStatusFilter = false;
            searchParams.delete('paymentStatus');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
        setGlobalFilter(clone);
        setPaymentStatusFilter(payState);
        setUsedFilterCount(clone2);
        onFilterCountChangeHandle(clone2);
        // fetch wallet transactions
        setFilter(clone);
    }

    const selectedDateToHandle = (date) => {

        let clone = {...globalFilter};
        let clone2 = {...usedFilterCount};
        if(date) {
            clone.invoiceDate_lte = moment(date).format('YYYY-MM-DD') + '%2023:59:59';

            clone2.toFilter=true;
            setSelectedDateTo(date);
            searchParams.set('invoiceDate_lte', clone.invoiceDate_lte);
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        } else{
            delete clone['invoiceDate_lte'];
            clone2.toFilter=false;
            setSelectedDateTo('');
            searchParams.delete('invoiceDate_lte');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
        setGlobalFilter(clone);
        // reset month and quick filter
        searchParams.delete('year');
        const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
        history.pushState(null, "", newRelativePathQuery);
        setYearFilter("");
        clone2.yearFilter = false;
        setUsedFilterCount(clone2);
        onFilterCountChangeHandle(clone2);
        setFilter(clone);
    };

    const selectedDateFromHandle = (date) => {

        let clone = {...globalFilter};
        let clone2 = {...usedFilterCount};
        if(date) {
            clone.invoiceDate_gte = moment(date).format('YYYY-MM-DD') + '%2000:59:59';

            clone2.fromFilter=true;
            setSelectedDateFrom(date);
            searchParams.set('date_gte', clone.invoiceDate_gte);
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        } else{
            delete clone['invoiceDate_gte'];
            clone2.fromFilter=false;
            setSelectedDateFrom('');
            searchParams.delete('invoiceDate_gte');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
        searchParams.delete('year');
        const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
        history.pushState(null, "", newRelativePathQuery);
        setGlobalFilter(clone);
        // reset month and quick filter
        clone2.yearFilter = false;
        setUsedFilterCount(clone2);
        setYearFilter("");
        onFilterCountChangeHandle(clone2);
        setFilter(clone);
    };

    const onYearSelectHandle = (year) => {

        // should vaildate filter combo
        // reset all other time or date filter!
        let clone = {...globalFilter};
        let clone2 = {...usedFilterCount};

        if (year === "") {
            // reset time / date filter
            delete clone.year;
            clone2.yearFilter = false;
            searchParams.delete('year');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
            setYearFilter("");

        } else {

            //let _month = '' + month;
            //if (_month.length == 1) _month = '0' + _month;

            // compute created_lt and created_gte
            //const prefix = moment().format('YYYY') + '-' + _month + '-01';


            clone.year = year;
            clone2.yearFilter = true;
            searchParams.set('year',year);
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
            //clone.limit = 100000;
        }

        setGlobalFilter(clone);
        // reset datepicker
        if (selectedDateFrom !== null) setSelectedDateFrom(null);
        if (selectedDateTo !== null) setSelectedDateTo(null);
        // reset quick filter
        setYearFilter(year);
        setUsedFilterCount(clone2);
        onFilterCountChangeHandle(clone2);
        searchParams.delete('invoiceDate_lte');
        searchParams.delete('invoiceDate_gte');
        const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
        history.pushState(null, "", newRelativePathQuery);
        // fetch wallet transactions
        setFilter(clone);
    };

    const onNameFilterChange = (val) => {

        setNameFilter(val);                  // set status filter
        let clone = {...globalFilter};
        let clone2 = {...usedFilterCount};
        Object.assign(clone,globalFilter);              // get current filter settings (all filter)

       if (val !== null) {
            clone.name = val.replaceAll(" ", "");
            clone2.nameFilter = true;
            searchParams.set('name', val);
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        } else {
            delete clone['name'];
            clone2.nameFilter = false;
            searchParams.delete('name');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
        onFilterCountChangeHandle(clone2);
        setGlobalFilter(clone);
        setFilter(clone);                 // cloned object must be used because global filter is not yet updated
    };

    const onSystemFilterChange = (val) => {
        console.log(val,'val')
        setSystemFilter({value:val});                  // set status filter
        let clone = {...globalFilter};
        let clone2 = {...usedFilterCount};
        Object.assign(clone,globalFilter);              // get current filter settings (all filter)

        if (val !== null) {
            clone.sys = val;
            clone2.systemFilter = true;
            searchParams.set('system', val);
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        } else {
            delete clone['system'];
            clone2.systemFilter = false;
            searchParams.delete('system');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
        onFilterCountChangeHandle(clone2);
        setGlobalFilter(clone);
        setFilter(clone);
    };

    const onWarningLevelFilterChange = (val) => {

        setWarningLevelFilter(val);                  // set status filter
        let clone = {...globalFilter};
        let clone2 = {...usedFilterCount};
        Object.assign(clone,globalFilter);              // get current filter settings (all filter)

        if (val !== null) {
            clone.WarningLevel = val;
            clone2.WarningLevelFilter = true;
            searchParams.set('WarningLevel', val);
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        } else {
            delete clone['WarningLevel'];
            clone2.systemFilter = false;
            searchParams.delete('WarningLevel');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
        onFilterCountChangeHandle(clone2);
        setGlobalFilter(clone);
        setFilter(clone);
    };

    const onExportXLS = () => {

        const that = this;
        let params = '', count=0;

        for (var key in globalFilter) {
            if (count > 0) params += '&' + key + '=' + globalFilter[key];
            else params += '?' + key + '=' + globalFilter[key];
            count++;
        }

        const xmlHttp = new XMLHttpRequest();

        xmlHttp.open("GET", getApiHost() + '/users/export'+params, true);

        //  xmlHttp.setRequestHeader('Accept', 'application/json')
        xmlHttp.setRequestHeader('Authorization', 'Bearer ' + Biscuit.get('token'));
        xmlHttp.setRequestHeader('Content-Language', Biscuit.get('user.lang').replace('-','_'));
        xmlHttp.setRequestHeader('Accept-Language',Biscuit.get('user.lang').replace('-','_'));
        xmlHttp.responseType = "blob";

        xmlHttp.onload = function() {
            const blob = new Blob([xmlHttp.response], { type: 'application/xls' });
            FileSaver.saveAs(blob, t("users") + " " + get_today() + ".xlsx");
        };
        xmlHttp.send(null);
    };

    const get_today = () => {
        let today = new Date();
    
        let day = today.getDate(); // Tag
    
        // Monatsangabe startet bei 0!
        let month = today.getMonth()+1; // Monat
    
        let year = today.getFullYear(); // Jahr
        if(day < 10) {
          day = '0'+ day;
        }
        if(month < 10) {
          month = '0'+ month;
        }
        today = day + '.' + month + '.' + year;
    
        return today;
    };

let styleClass={};
/*if(Biscuit.get('user.is_superuser') === 'true'){
    styleClass={minWidth:"280px"}
}*/
const onToggleDropdown = (nextShow, meta) => {
    if(nextShow){
        $('.sticky-top-sortbar').addClass('hide');
    } else {
        $('.sticky-top-sortbar').removeClass('hide');
    }
}
    const dateKeyDownHandle = (e) => {
        console.log("key down date: ",e);
    };

    const initYearList = () => {

        let year = [{name:'- ' + t('select year') + ' -',value:""}];
        let startYear = 2014;
        const currentYear = moment().year();

        for (let i=currentYear;i>=startYear;i--) {
            year.push({
                name: i,
                value: i
            });
        }
        return year;
    };
    let years = initYearList();
    return (
        <aside
            id="inb-c-sidebar"
            className="resources-sidebar"
            style={{float:'left'}}>
            <header className="inb-c-left-bar__title sticky-top">
                <h1 className="inb-page-title">{t("invoices",null,'capital')}</h1>
               <aside className="inb-c-item__actions">
                  <DropdownButton id="dropdown-basic-button" title="..." drop="down" menuAlign="down"  bsPrefix="button round" onToggle={onToggleDropdown}>
                    <ul className="inb-dropdown__list" style={styleClass}>

                       {/* <li>
                             <Dropdown.Item href='#' onClick={() => sync(1)}>
                                 <i className="ico-inb inb-fi-voucher"></i>
                                                {t('sync invoices', null, 'capital')}
                                            </Dropdown.Item>
                                        </li>
                        <li>
                            <Dropdown.Item href='#' onClick={() => sync(0)}>
                                <i className="ico-inb inb-fi-voucher"></i>
                                {t('sync invoices complete', null, 'capital')}
                            </Dropdown.Item>
                        </li>*/}
                        <li>
                            <Dropdown.Item href='#' onClick={() => uploadInvoiceCSV()}>
                                <i className="ico-inb inb-fi-voucher"></i>
                                {t('upload csv', null, 'capital')}
                            </Dropdown.Item>
                        </li>
                        <li>
                            <Dropdown.Item href='#' onClick={() => getSepaXML()}>
                                <i className="ico-inb inb-fi-voucher"></i>
                                {t('get sepa xml', null, 'capital')}
                            </Dropdown.Item>
                        </li>
                    </ul>
                  </DropdownButton>
                </aside>
            </header>
            <div className="sticky-top-filter">
                <aside id="inb-selected-filters">
                    {filterCount > 0 && <ul>
                        <p>
                            <i className="fi fi-filter"> </i>
                            <span id="inb-selected-filters__count">
                               {" " + filterCount}
                             </span>

                            {" " + t('filter_selected')}
                            <a href="#"
                               id="inb-selected-filters__unset"
                               className="unset-filter"
                               title={t('unselect_all_filter')} onClick={(e) => {
                                resetFilter(e)
                            }}>
                                x
                            </a>
                        </p>
                    </ul>}
                </aside>
                <SidebarFilter
                    id="inb-c-left-bar-flist--user-status"
                    heading={t('system')}
                    type="list"
                    data={
                        getFilterData( [
                            {name: t('all'), summaryItem: 'allSystemsCount', value: '' },
                            {name: t('Freizeitplan'), summaryItem: 'fpCount', value: 'fp'},
                            {name: t('Inbooma'), summaryItem: 'ibCount', value: 'inbooma'}
                        ],externInvoicesSummaryPending,externInvoicesSummary)
                    }
                    dataKey="value"
                    selected={typeof systemFilter?.value !== 'undefined' && systemFilter?.value !== null ? systemFilter.value : ''}
                    summaryPending={externInvoicesSummaryPending}
                    onChangeHandle={onSystemFilterChange}/>
                <SidebarFilter
                    id="inb-c-left-bar-flist--user-status"
                    heading={t('paymentStatus')}
                    type="list"
                    data={
                         getFilterData( [
                            {name: t('all'), summaryItem: 'allPaymentStatusCount', value: '' },
                            {name: t('paid'), summaryItem: 'paidCount',value: 'Bezahlt'},
                            {name: t('unpaid'), summaryItem: 'unpaidCount',value: 'Unbezahlt'}
                        ],externInvoicesSummaryPending,externInvoicesSummary)
                    }
                    dataKey="value"
                    selected={paymentStatusFilter}
                    summaryPending={externInvoicesSummaryPending}
                    onChangeHandle={onPaystateSelectHandle}/>

                <SidebarFilter
                    id="inb-c-left-bar-flist--user-status"
                    heading={t('paymentMethod')}
                    type="list"
                    data={
                        getFilterData( [
                            {name: t('all'), summaryItem: 'allPaymentMethodsCount', value: '' },
                            {name: t('Lastschrift'),summaryItem:  "sepaCount", value: 'Lastschrift'},
                            {name: t('Überweisung'),summaryItem:  "transferCount", value: 'Überweisung'}
                        ],externInvoicesSummaryPending,externInvoicesSummary)
                    }
                    selected={paymentMethodFilter}
                    dataKey="value"
                    summaryPending={externInvoicesSummaryPending}
                    onChangeHandle={onPaymentTypeSelectHandle}/>
                <SidebarFilter
                    id="inb-c-left-bar-flist--transactions-date"
                    heading={t('timespan',null,'capital')}
                    type="datePicker"
                    data={[{
                        name: "invoiceDate_from",
                        className: "noBorders-noBackground",
                        dateFormat: "dd.MM.y",
                        selected: selectedDateFrom,
                        onChangeHandle: selectedDateFromHandle,
                        onKeyDownHandle: dateKeyDownHandle,
                        placeholder: t('valid_from',null,'capital') + ' ...'
                    },{
                        name: "invoiceDate_to",
                        className: "noBorders-noBackground",
                        dateFormat: "dd.MM.y",
                        selected: selectedDateTo,
                        onChangeHandle: selectedDateToHandle,
                        onKeyDownHandle: dateKeyDownHandle,
                        placeholder: ' ...' + t('valid_to',null,'capital'),
                    }]}/>
                <SidebarFilter
                    id="inb-c-left-bar-flist--transactions-month"
                    heading={t('year',null,'capital')}
                    type="select"
                    data={years}
                    dataKey="value"
                    selected={yearFilter}
                    onChangeHandle={onYearSelectHandle}/>
                <SidebarFilter
                    id="inb-c-left-bar-flist--transactions-month"
                    heading={t('warningLevel',null,'capital')}
                    type="select"
                    data={[
                        {name: t('all'), value : ''},
                        {name: 0, value: 0},
                        {name: 1, value: 1},
                        {name: 2, value: 2}
                    ]}
                    dataKey="value"
                    selected={warningLevelFilter}
                    onChangeHandle={onWarningLevelFilterChange}/>
                <SidebarFilter
                    id="inb-c-left-bar-flist--transactions-month"
                    heading={t('name',null,'capital')}
                    type="select"
                    data={nameList}
                    dataKey="value"
                    selected={nameFilter}
                    onChangeHandle={onNameFilterChange}/>
            </div>
            {/*<ul id="inb-c-left-bar-flist--user-role"
                className="inb-vert-list">
                <span className="inb-list-title">
                {t('role')}
                </span>
                <ListItem
                    className={roleFilter.value == 'all' ? 'active' : ''}
                    key={'role_all'}>

                    <span onClick={() => onRoleFilterChange('all')}>
                    {t('all')}
                    </span>
                </ListItem>
              {props.getAvailableRoles().map(role => (
              <ListItem
                  className={role === roleFilter.value ? 'active' : ''}
                  key={role}>

                  <span onClick={() => onRoleFilterChange(role)}>
                    {t('role_' + role)}
                  </span>

                  {roleFilter.value !== null && roleFilter.value !== 'all' && roleFilter.value == role &&
                  <a
                    href="#"
                    className="unset-filter"
                    onClick={() => onRoleFilterChange('all')}
                    title={t('unselect_filter')}>
                    x
                  </a>
                  }
              </ListItem>
              ))}
            </ul>}*/}
            <footer
                className="inb-c-left-bar__footer small-only-float-container"
                    data-inb-action-link="write">
                <a href="#"
                    id="toggle-left-bar"
                    className="button secondary show-for-small-only" onClick={(e) => onToggleLeftBar(e)}>
                        <i className="fi fi-filter"></i>
                        <span className="show-for-sr">{t('open_filter_menu')}</span>
                </a>
           {/* { rbac.hasPermission('write') &&
                <NewUserButton
                    url={"/users/add?path=" + (props.activeSubmenu == 'staff' ? '/users/staff' : '/users') + currentUrl.search.replace('?','&')}
                />
            }*/}
            </footer>
        </aside>
    );
};

export default InvoiceSidebar;